export default __webpack_public_path__ + "static/media/avatar-transparent.569e0eb1.png";